<template>
  <div class="asso-team-portal">
    <EditTournament :association_id="association_id" :eventId="eventId" :eventExactStartDate="eventExactStartDate"
      :eventExactEndDate="eventExactEndDate" :ageOptions="ageOptions" :ratingOptions="ratingOptions" />
    <ManageTournamentSeedars :association_id="association_id" />
    <AddTournament :eventExactStartDate="eventExactStartDate" :eventExactEndDate="eventExactEndDate" :eventId="eventId"
      :currentIsAdmin="currentIsAdmin" :association_id="association_id" :ageOptions="ageOptions" :events="events"
      :ratingOptions="ratingOptions" :bracketFormats="bracketFormats" />
    <TournamentAddGameModal :association_id="association_id" :eventId="eventId" />
    <TournamentTeamsModal :association_id="association_id" />
    <div class="asso-sec-content">
      <div class="d-flex align-items-center"
        :class="{ 'justify-content-between': divisionsTotal, 'justify-content-end': !divisionsTotal }">
        <p class="count-wrap" v-if="divisionsTotal">{{ divisionsTotal }} <span>
            {{ divisionsTotal > 1 ? 'divisions' :
              'division' }}
          </span></p>
        <button class="btn manage-btn" @click="openModal()" v-if="currentIsAdmin == '1'">
          Add Division
        </button>
      </div>
      <b-row class="no-gutters" v-if="tournamentsData.length > 0">
        <div class="col-12 products-column">
          <div class="event-card">
            <div v-for="(tournament) in tournamentsData" :key="tournament.id"
              class="team-card d-flex align-items-center justify-content-between flex-wrap">
              <!-- Left Side -->
              <div class="stats-link d-block division-name">
                <div class="message-topic division-date" v-if="tournament.exactStartDate && tournament.exactEndDate">{{
                  formatTournamentDate(tournament.exactStartDate,
                    tournament.exactEndDate) }}</div>
                <div class="reset-button" @click="handleTournamentClick(tournament)">
                  {{ tournament.tournamentName }}
                </div>
                <div class="division-name">{{ tournament.teamCounts }} {{ tournament.teamCounts > 1 ? 'Teams' : 'Team'
                }}</div>
                <div class="division-name"
                  v-if="tournament.selected_seed_criteria && tournament.selected_seed_criteria.length">Seed: {{
                    tournament.selected_seed_criteria.map(c => c.seeding_criteria.criteria_name).join(', ')}}</div>
                <div class="division-name" v-if="tournament.pool_game_guarantee && tournament.bracket_format_name">
                  Format: {{ tournament.pool_game_guarantee }} games round robin to seed {{ tournament.tournamentName }}
                  {{ tournament.bracket_format_name.toLowerCase() }} bracket.</div>
              </div>

              <!-- Right Side (Action) -->
              <div v-if="currentIsAdmin == '1'" class="d-flex align-items-center" style="gap: 5px;">
                <button class="create-event" @click="callManageTeamModal(tournament)">
                  <img src="../../assets/Svg/people-outlined.svg" class="mr-1" alt="team" />
                  <span>Teams</span>
                </button>
                <div class="opt edit-btn m-0" @click.stop="toggleMenu(tournament.id, $event)"
                  v-click-outside="hideMenu">
                  <img src="../../assets/Svg/ellipse.svg" alt="" />
                  <div class="sub-setting-options edit-event-options" v-if="openMenuId === tournament.id">
                    <ul class="d-block pb-0">
                      <li class="cursor-pointer" @click.stop="handleMenuAction(tournament, 'edit')">
                        <img src="../../assets/Svg/team/team-options/edit-2.svg" alt="edit" />
                        <p>Edit Division</p>
                      </li>
                      <li class="cursor-pointer" @click.stop="handleMenuAction(tournament, 'criteria')">
                        <img src="../../assets/Svg/seed-criteria.svg" alt="seed criteria" />
                        <p>Seed Criteria</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-row>

      <div v-if="tournamentsData.length" v-observe-visibility="handleScrolledToButtom">
      </div>

      <div v-if="
        (!tournamentsData || tournamentsData.length === 0) && showLoaderTournament === 0" class="no-event-wrap">
        <img src="../../assets/Svg/no-data.svg" alt />
        <p class="header">No division found.</p>
        <p class="info">There are no division found to display.</p>
      </div>
      <div class="products-list-shim p-0 mt-3" v-if="tournamentsData.length === 0 && showLoaderTournament == 1">
        <content-placeholders :rounded="true">
          <content-placeholders-img />
          <content-placeholders-heading />
        </content-placeholders>
        <content-placeholders class="mt-3" :rounded="true">
          <content-placeholders-img />
          <content-placeholders-heading />
        </content-placeholders>
      </div>
    </div>

    <div class="asso-sec-content mt-3" v-if="tournamentsData.length > 0" ref-box-score-section>
      <div class="d-flex justify-content-between flex-wrap align-items-center" style="gap: 5px;">
        <!-- Tournament Dropdown -->
        <div class="position-relative d-flex flex-wrap align-items-center" style="gap: 5px;">
          <div class="dropdown-wrapper">
            <div class="dropdown-button" :class="{
              'has-value': selectedTournamentName,
            }" @click="toggleDropdown" v-click-outside="closeDropdown">
              <div>
                <p class="association-data">{{ selectedTournamentName || "Division" }}</p>
              </div>
              <img :src="arrow_down" alt="arrow-down" />
            </div>

            <div class="dropdown-menu-content" v-if="activeDropdown">
              <input v-model="searchQuery" type="text" class="form-control" placeholder="Search Division" @click.stop
                @input="onSearchInput" @keyup="onSearchInputTeam" @change="onSearchInputTeam" />
              <div v-if="filteredTournaments.length === 0" class="no-results">No results found</div>
              <div class="dropdown-menu-content-inner" ref="dropdownMenu" v-else>
                <div v-for="tournament in filteredTournaments" :key="tournament.id" class="dropdown-item"
                  @click="selectTournament(tournament)">
                  <span>{{ tournament.tournamentName }}</span>
                </div>
                <div class="position-relative py-3" v-if="showLoaderTournament === 1">
                  <div class="lds-dual-ring-media"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="dropdown-wrapper" v-click-outside="closeDropdownTeam">
            <button class="dropdown-button" :class="{
              'has-value': selectedTeams.length > 0,
            }" @click="toggleTeamDropdown">
              <span>{{
                selectedTeams.length >= 1
                  ? selectedTeams[0]
                  : "Teams"
              }}</span>
              <div class="badge-wrapper" v-if="selectedTeams.length > 1">
                <span class="counter-badge">+{{ selectedTeams.length - 1 }}</span>
              </div>
              <img :src="arrow_down" alt="arrow-down" />
            </button>
            <div class="dropdown-menu-content" v-show="teamDropdownOpen">
              <div v-if="showLoader" class="lds-dual-ring-refresh"></div>
              <div class="data-wrap" v-if="!showLoader">
                <input type="text" v-model="teamSearchQuery" placeholder="Search Teams" class="form-control" @click.stop
                  @input="onSearchInputTeam" />
                <div class="dropdown-menu-content-inner">
                  <div v-if="filteredTeams.length === 0 && !showLoader" class="no-results">
                    No result found
                  </div>
                  <div v-else>
                    <div v-for="team in filteredTeams" :key="team.id" class="dropdown-item"
                      :class="{ selected: selectedTeams.includes(team.team.team_name) }"
                      @click="toggleTeamSelection(team)">
                      <input type="checkbox" :checked="selectedTeams.includes(team.team.team_name)"
                        class="checkbox circular-checkbox" />
                      <span>{{ team.team.team_name }}</span>
                    </div>
                  </div>
                </div>
                <!-- Clear Selection Button -->
                <button class="clear-btn" @click.stop="clearTeamSelection"
                  v-if="teamSearchQuery || selectedTeams.length > 0">
                  Clear Selection
                </button>
              </div>
            </div>
          </div>
          <div class="left-part-btns justify-content-start">
            <button :class="{ active: selectedFilter === 'all' }" @click="filterGames('all')">
              All
            </button>
            <button :class="{ active: selectedFilter === 'ongoing' }" @click="filterGames('ongoing')">
              Ongoing
            </button>
            <button :class="{ active: selectedFilter === 'final' }" @click="filterGames('final')">
              Final
            </button>
          </div>
        </div>
        <div class="d-flex justify-content-end" v-if="currentIsAdmin == '1'">
          <button class="btn manage-btn" @click="callModal(selectedTournament)">
            Add Game
          </button>
        </div>
      </div>
      <TournamentGames ref="gameList" :currentIsAdmin="currentIsAdmin" :currentIsUmpire="currentIsUmpire"
        :tournamentData="tournamentsData" :showLoader="showLoaderTournament" :association_id="association_id"
        :associationId="associationId" :events="events" />
    </div>
  </div>
</template>

<script>
import TournamentGames from "../Tournaments/TournamentGames.vue";
import TournamentAddGameModal from "../Tournaments/Modals/TournamentAddGameModal.vue";
import TournamentTeamsModal from "../Tournaments/Modals/TournamentTeamsModal.vue";
import AddTournament from "./Modals/AddTournament.vue";
import EditTournament from './Modals/EditTournament.vue';
import ManageTournamentSeedars from "../Tournaments/Modals/TournamentSeedarModal.vue";

import axios from "axios";
export default {
  name: "AssociationTournamentInfo",
  components: {
    AddTournament,
    TournamentGames,
    TournamentAddGameModal,
    TournamentTeamsModal,
    EditTournament,
    ManageTournamentSeedars

  },
  data() {
    return {
      searchQuery: "",
      ageOptions: [],
      bracketFormats: [],
      ratingOptions: [],
      selectedTournament: null,
      activeDropdown: false,
      arrow_down: require('@/assets/Svg/arrow-down.svg'),
      currentIsUmpire: "0",
      associationId: 0,
      selectedFilter: localStorage.getItem("gameFilter") || "all", // Default filter
      previousScrollTop: 0,

      teamData: [],
      selectedTeams: [],
      teamDropdownOpen: false,
      teamSearchQuery: '',
      page: 1,
      teamLastPage: 1,
      search_icon: require('@/assets/Svg/Search.svg'),

      openMenuId: null,
    };
  },
  computed: {
    selectedTournamentName() {
      const tournament = this.tournamentsData.find(t => t.guid === this.selectedTournament);
      return tournament ? tournament.tournamentName : "";
    },
    sortedTournaments() {
      if (!this.tournamentsData) return [];
      return [...this.tournamentsData].sort((a, b) => {
        const nameA = (a.tournamentName || "").toUpperCase();
        const nameB = (b.tournamentName || "").toUpperCase();
        return nameA.localeCompare(nameB);
      });
    },
    filteredTournaments() {
      const query = this.searchQuery.trim().toLowerCase();
      return this.sortedTournaments.filter(t =>
        (t.tournamentName || '').toLowerCase().includes(query)
      );
    },
    filteredTeams() {
      const query = this.teamSearchQuery.trim().toLowerCase();
      return this.teamData.filter(team =>
        (team.team.team_name || '').toLowerCase().includes(query)
      );
    },
    selectedTeamNames() {
      return this.selectedTeams.map(teamId => {
        const team = this.teamData.find(t => t.id === teamId);
        return team ? team.team.team_name : '';
      }).join(', ');
    }
  },
  watch: {
    events: {
      handler(newVal) {
        console.log("events changed:", newVal);
      },
      deep: true // optional: only needed if `events` is a nested object or array
    },
    tournamentsData: {
      handler(newData) {
        if (!newData || newData.length === 0) return;

        // Create a sorted copy
        const sortedData = [...newData].sort((a, b) => {
          const nameA = (a.tournamentName || '').toUpperCase();
          const nameB = (b.tournamentName || '').toUpperCase();
          return nameA.localeCompare(nameB);
        });

        const storedTournamentID = localStorage.getItem("tournamentID");

        if (storedTournamentID) {
          this.selectedTournament = storedTournamentID;
          this.getTournamentTeams(storedTournamentID);
        } else {
          this.selectedTournament = sortedData[0].guid;
          localStorage.setItem("tournamentID", this.selectedTournament);
          this.getTournamentTeams(this.selectedTournament);
        }
      },
      immediate: true
    },
  },
  props: {
    tournamentsData: {
      type: Array,
    },
    eventId: {
      // Define umpires prop to receive the umpire data
      type: Number,
    },
    showLoaderTournament: {
      type: Number,
    },
    divisionPage: {
      type: Number,
    },
    association_id: {
      type: Number,
    },
    currentIsAdmin: {
      type: String,
    },
    divisionlastPage: {
      type: Number,
    },
    eventExactStartDate: {
      type: String,
    },
    eventExactEndDate: {
      type: String,
    },
    divisionsTotal: {
      type: Number
    },
    events: {
      type: Object
    }
  },
  methods: {
    onSearchInput(e) {
      this.searchQuery = e.target.value;
    },

    onSearchInputTeam(e) {
      this.teamSearchQuery = e.target.value;
    },

    toggleMenu(tournamentId, event) {
      // Stop propagation to prevent immediate outside click detection
      event.stopPropagation()

      // Close all other menus first
      if (this.openMenuId !== tournamentId) {
        this.openMenuId = null
      }

      // Toggle the clicked menu
      this.openMenuId = this.openMenuId === tournamentId ? null : tournamentId
    },

    hideMenu() {
      this.openMenuId = null
    },

    handleMenuAction(tournament, action) {
      this.hideMenu()
      if (action === 'edit') {
        this.callModalEditDivsion(tournament)
      } else {
        this.callModalCriteria(tournament)
      }
    },

    callModalCriteria(tournament) {
      this.$root.$emit("openManageTourSeedarsModal", tournament);
    },
    handleTournamentClick(tournament) {
      localStorage.setItem('tournamentID', tournament.guid);
      this.selectTournament(tournament);

      this.$nextTick(() => {
        this.$emit('scrollToBoxScore');
      });
    },
    callModalEditDivsion(tournament) {
      this.$root.$emit("openTournamentEditModal", {
        tournament,
        bracketFormats: this.bracketFormats,
      });
    },
    callModal(tournament) {
      this.$root.$emit("openTournamentAddGameModal", tournament);
    },
    callManageTeamModal(tournament) {
      this.$root.$emit("openTournamentTeamsModal", tournament);
    },
    toggleDropdown() {
      this.searchQuery = '';
      this.activeDropdown = !this.activeDropdown;
      this.$nextTick(() => {
        if (this.activeDropdown && this.$refs.dropdownMenu) {
          this.$refs.dropdownMenu.addEventListener("scroll", this.onDropdownScroll);
        } else if (this.$refs.dropdownMenu) {
          this.$refs.dropdownMenu.removeEventListener("scroll", this.onDropdownScroll);
        }
      });
    },
    onDropdownScroll() {
      this.$emit("get-division-pagination");
    },
    closeDropdown() {
      this.activeDropdown = false;
    },
    toggleTeamDropdown() {
      this.teamDropdownOpen = !this.teamDropdownOpen;
    },

    toggleTeamSelection(team) {
      const teamName = team.team.team_name;
      const index = this.selectedTeams.indexOf(teamName);
      if (index === -1) {
        this.selectedTeams.push(teamName); // Store the full object
      } else {
        this.selectedTeams.splice(index, 1); // Remove by index
      }
      // Emit event with selected team names
      this.$root.$emit("filterGamesByTeams", this.selectedTeams);
    },

    clearTeamSelection() {
      this.selectedTeams = [];
      this.teamSearchQuery = '';
      this.$root.$emit("filterGamesByTeams", []);
    },

    closeDropdownTeam() {
      this.teamDropdownOpen = false;
    },

    async selectTournament(tournament) {
      this.selectedTournament = tournament.guid;
      this.teamData = []; // Clear existing teams data
      this.selectedTeams = []; // Clear selected teams
      this.page = 1;
      await this.getTournamentTeams(tournament.guid);
      this.$root.$emit("changeDivision", this.selectedTournament);
      localStorage.setItem("division", this.selectedTournament);
      this.closeDropdown();
    },
    formatTournamentDate(start, end) {
      const startDate = new Date(start);
      const endDate = new Date(end);

      if (isNaN(startDate) || isNaN(endDate)) {
        return "";
      }

      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      const monthStart = months[startDate.getMonth()];
      const dayStart = startDate.getDate();

      const monthEnd = months[endDate.getMonth()];
      const dayEnd = endDate.getDate();

      const startYear = startDate.getFullYear();
      const endYear = endDate.getFullYear();

      if (startYear === endYear) {
        return `${monthStart} ${dayStart} to ${monthEnd} ${dayEnd}, ${startYear}`;
      } else {
        return `${monthStart} ${dayStart}, ${startYear} to ${monthEnd} ${dayEnd}, ${endYear}`;
      }
    }
    ,

    redirectToTournament(item) {
      const tournamentId = item.guid;
      this.$router.push({ name: "Tournament", params: { id: tournamentId } });
    },
    openModal: function () {
      this.$root.$emit("openAddTournamentModal");
    },
    handleActionClick() {
      this.$root.$emit("openEditTournamentEllipsis");
    },
    handleScrolledToButtom(isVisible) {
      if (this.divisionPage >= this.divisionlastPage) {
        return;
      }
      if (isVisible) {
        this.$root.$emit("getDivisionPagination"); // Emit event to notify parent component
      }
    },
    async getTournamentTeams(guid) {
      this.showLoader = 1;
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/teams/getTournamentTeams`,
          { tournament_guid: guid ? guid : this.tournamentData[0].guid, page: this.page, association_id: this.association_id, } // Include the page parameter
        );

        if (response.data.statusCode === 200) {
          const newData = response.data.data.data;
          newData.sort((a, b) => a.team_sr_no - b.team_sr_no);

          if (this.page === 1) {
            this.teamData = newData;
          } else {
            // For pagination, filter out duplicates before adding
            const existingIds = new Set(this.teamData.map(team => team.id));
            const uniqueNewData = newData.filter(team => !existingIds.has(team.id));
            this.teamData = [...this.teamData, ...uniqueNewData];
          }

          this.teamLastPage = response.data.data.last_page;
          this.showLoader = 0;
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          this.$router.push({ name: "Teams" });
          this.showLoader = 0;
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoader = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoader = 0;
      } finally {
        this.showLoader = 0;
      }
    },
    getAgeGroup() {
      axios
        .get(`${process.env.VUE_APP_API_URL}getAgeGroup`)
        .then((response) => {
          if (response.data.statusCode == 200) {
            this.ageOptions = response.data.data.list;
          } else {
            this.errorMessage = response.data.message;
          }
        });
    },
    getBracketFormat() {
      axios
        .get(`${process.env.VUE_APP_API_URL}getBracketFormats`)
        .then((response) => {
          if (response.data.statusCode == 200) {
            this.bracketFormats = response.data.data.list;
          } else {
            this.errorMessage = response.data.message;
          }
        });
    },
    getAllRating() {
      axios
        .get(`${process.env.VUE_APP_API_URL}getAllRatings`)
        .then((response) => {
          if (response.data.statusCode == 200) {
            this.ratingOptions = response.data.data.list;
          } else {
            this.errorMessage = response.data.message;
          }
        });
    },
    filterGames(filter) {
      this.selectedFilter = filter;
      localStorage.setItem('gameFilter', this.selectedFilter);
      this.$root.$emit("FilterGames", this.selectedFilter);
    },
  },
  mounted() {
    this.getAgeGroup();
    this.getAllRating();
    this.getBracketFormat();
  },
};
</script>
